__NODE__ && require("dotenv").config();

// Small helper to fetch environment variables safely
const getEnvVar = (key, fallback) => (__NODE__ && process.env[key]) || fallback;

export const QUOTE_API_URL = getEnvVar(
  "QUOTE_API_URL",
  "https://quoteapi-uat.driver-insurance.co.uk",
);
export const INSURANCE_API_URL = getEnvVar(
  "INSURANCE_API_URL",
  "https://insuranceapi-uat.driver-insurance.co.uk",
);
export const BUY_API_URL = getEnvVar(
  "BUY_API_URL",
  "https://buyapi-uat.driver-insurance.co.uk",
);
export const BASE_URL = getEnvVar(
  "BASE_URL",
  "https://portal-uat.driver-insurance.co.uk",
);
export const HPP_URL = getEnvVar(
  "HPP_URL",
  "https://pay.sandbox.realexpayments.com/pay",
);

export const UBER_AUTH_REDIRECT_PORTAL_LOGIN_PATH = "/login/uber";
export const TAXI_QUOTE_RD_DISPLAY = true;
export const TAXI_QUOTE_BRANDREF = "DITXWEB";
export const UBER_AUTH_REDIRECT_PATH = "/taxi/quote/start";
export const UBER_AUTH_CLIENT_ID = "UNHWTpT3HVqU_odx-nl2dhS-Yxusz_0p";
export const UBER_AUTH_RESPONSE_TYPE = "code";
export const TAXI_ENABLE_DATEPASSED = false;
export const TAXI_QUOTE_DISPLAY_IGNORE = false;
export const QUOTE_API_SESSION_COOKIE = ".QuoteApiAspCore.Session";
export const TAXI_QUOTE_SOB = "DITXWEB";

export const PCL_CONFIRM_URL = `${BASE_URL}/agreement/pcl/confirm`;
export const PCL_CANCEL_REDIRECT_URL = `${BASE_URL}/agreement/pcl/cancel`;
export const PCL_ERROR_REDIRECT_URL = `${BASE_URL}/agreement/pcl/error`;
export const PCL_DECLINE_REDIRECT_URL = `${BASE_URL}/agreement/pcl/decline`;

export const CACHE_DURATION = 10 * 60 * 1000;

export const ALLOWED_ORIGINS = [
  "localhost:3000",
  "localhost:3001",
  "yourdomain.com",
];

export const TAXI_FINANCE_INTEREST = 13;
export const TAXI_FINANCE_APR = 26.9;
export const ENABLE_SIMPLELIST_CACHING = false;

export const MJ_APIKEY_PUBLIC = getEnvVar("MJ_APIKEY_PUBLIC", "");
export const MJ_APIKEY_PRIVATE = getEnvVar("MJ_APIKEY_PRIVATE", "");
export const MJ_FROM_ADDRESS = getEnvVar("MJ_FROM_ADDRESS", "");
export const MJ_TO_SUPPORT = getEnvVar("MJ_TO_SUPPORT", "");
export const MJ_TO_CLAIMS = getEnvVar("MJ_TO_CLAIMS", "");
